import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getReferidos } from "../api";
import "../assets/css/bootstrap.min.css";
import { motion, AnimatePresence } from "framer-motion";
import "../assets/css/style.css";
import { useDynamicSplash } from "../hooks/useDynamicSplash";

const Referidos = () => {
  const [referidos, setReferidos] = useState([]);
  const [loadingReferidos, setLoadingReferidos] = useState(false);
  const showSplash = useDynamicSplash(loadingReferidos);
  const [saldo, setSaldo] = useState(0);
  const navigate = useNavigate();
  const id_perfil = localStorage.getItem("id_perfil");

  // Reescribimos el historial para que swipe-back regrese a /perfil
  useEffect(() => {
    window.history.replaceState({}, "", "/perfil");
    window.history.pushState({}, "", "/referidos");
  }, []);

  useEffect(() => {
    let mounted = true;

    const cargarReferidos = async () => {
      setLoadingReferidos(true);
      document.body.style.overflow = "hidden";

      try {
        const data = await getReferidos(id_perfil);
        if (!mounted) return;
        setReferidos(data.referidos || []);
        setSaldo(data.saldo || 0);
      } finally {
        if (mounted) {
          setLoadingReferidos(false);
          document.body.style.overflow = "auto";
          window.scrollTo(0, 0);
        }
      }
    };

    if (id_perfil) {
      cargarReferidos();
    }
    return () => {
      mounted = false;
      document.body.style.overflow = "auto";
    };
  }, [id_perfil]);

  return (
    <>
      {showSplash && (
        <div id="splash">
          <img src="/assets/images/loading.gif" style={{ width: 300 }} alt="Cargando..." />
        </div>
      )}
      {!showSplash && (
       <motion.div
	      initial={{ y: "100%", opacity: 0 }}
	      animate={{ y: 0, opacity: 1 }}
	      exit={{ y: "100%", opacity: 0 }}
	      transition={{ duration: 0.7, ease: "easeInOut" }}
    	>
    <div className="app-container">
      <div className="connections-container">
        <div className="back-container">
          <button className="back-btn" onClick={() => navigate("/perfil")}>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
              <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48" d="M244 400L100 256l144-144M120 256h292" />
            </svg>
          </button>
        </div>
        <h2 className="connections-title">Tus referidos</h2>
      </div>
      {parseFloat(saldo) > 0 && (
      <div style={{
          backgroundColor: "#3f6aff",
          borderRadius: "20px",
          padding: "20px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          display: "flex",
          flexDirection: "column",
          gap: "0px",
          marginTop: 0, 
          marginRight: 15,
          marginLeft: 15,
          marginBottom: 20
        }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <span style={{ fontWeight: "600", fontSize: "16px", color: "#fff" }}>
                Tu saldo de referidos
              </span>
            </div>
          </div>
          <div style={{ fontWeight: "700", fontSize: "28px", color: "#fff" }}>
            Q{parseFloat(saldo).toFixed(2)}
          </div>
        </div>
        )}
      <div className="feature-list">
        {referidos.length > 0 ? (
          referidos.map((user) => (
            <div className="feature-item" key={user.id_perfil}>
              <div className="icon">
                <img
                  src={user.foto || "/assets/images/default.png"}
                  alt={user.nombre}
                  width="32"
                  height="32"
                  style={{ borderRadius: "50%" }}
                />
              </div>
              <div className="feature-text" style={{lineHeight:1}}>
                <h3>{user.nombre}</h3>
                {user.estado_pago && (
                <p className={`badge ${
                  user.estado_pago === "COMPLETADO" ? "badge-v" : "badge-w"
                }`}
                style={{
                  display: "inline-block",
                  color: "#fff",
                }}>{user.estado_pago}</p>
              )}
              </div>
            </div>
          ))
        ) : (
          <div className="no-data-wrapper" style={{height:300, marginTop:95}}>
            <div className="no-data">
              <img src="/assets/images/empty.svg" alt="Sin referidos" />
              <p>
                Aún no has invitado a nadie. <br />
                Comparte tu código y gana saldo por cada referido.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
    </motion.div>
    )}
    </>
  );
};

export default Referidos;
